import { render } from "./ProjectHours.vue?vue&type=template&id=3787e51a&ts=true"
import script from "./ProjectHours.vue?vue&type=script&lang=ts"
export * from "./ProjectHours.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__